import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@mui/material';
import { Box } from '@mui/system';
import { useDispatch } from 'react-redux';
import { pdfjs } from 'react-pdf';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import useAgreementSelector from '../../../../store/Slice/Agreement/AgreementSelector';
import CustomDate from '../../../../components/CustomDate';
import useLoginSelector from '../../../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../../../store/Slice/Global/GlobalSelector';
import {
  getStateData,
  getCityData,
  getBankDropdownData,
  getBankDropdownData2
} from '../../../../store/Slice/Global/GlobalSlice';
import {
  getBankTypeList,
  saveAgreementBankInfo
} from '../../../../store/Slice/Agreement/AgreementSlice';
import CustomInput from '../../../../components/CustomInput';
import CustomSelect from '../../../../components/CustomSelect';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function AggrementAddStep1({ setActiveStep, reviewData, setReviewData }) {
  const [open, setOpen] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [openBankExist, setOpenBankExist] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { stateDrop, CityDrop, BankDrop, BankList, BankDropdownData } = useGlobalSelector();
  const { rowId } = location?.state || {};
  const { AgreementEdit, AgreementListData, BankTypeDrop } = useAgreementSelector();

  // console.log('BankList', BankList);
  // console.log('BankTypeList', BankTypeDrop);
  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      bankMasterId: '',
      bankLoginTypeId: '',
      panNumber: '',
      gstin: '',
      bankCommissionTypeId: '',
      turnoverBenefit: '',
      loginCode: '',
      aggrementStartDate: '',
      bankAddress: '',
      bankAddress2: '',
      cityId: '',
      stateId: '',
      refCode: ''
    }
  });

  const selectedState = watch('stateId');

  const LoginTypes = [
    { label: 'DSA', value: '62' },
    { label: 'DST', value: '64' }
  ];

  const CommissionTypes = [
    { label: 'Branch', value: '68' },
    { label: 'Bank', value: '66' }
  ];

  const TurnoverBenefitOptions = [
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' }
  ];

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async (data) => {
    const selectedBank = (BankList || []).find(
      (b) => String(b.value) === String(data.bankMasterId)
    );

    // console.log('selected bank:', selectedBank);

    const credential1 = {
      userId: LoginData?.userId,
      companyId: LoginData?.companyId,
      aggrementId:
        location.pathname === '/agreement/edit' ? Number(rowId) : reviewData?.agreementId || null,
      bankId: AgreementEdit?.bankId || null,
      bankMasterId: Number(data.bankMasterId),
      bankName: selectedBank?.label || '',
      bankCommissionTypeId: Number(data.bankCommissionTypeId),
      bankLoginTypeId: Number(data?.bankLoginTypeId) || null,
      loginCode: data.loginCode,
      gstin: data.gstin,
      turnoverBenefit: data.turnoverBenefit === 'true',
      panNumber: data.panNumber,
      aggrementStartDate: data.aggrementStartDate,
      bankAddress: data.bankAddress,
      bankAddress2: data.bankAddress2,
      cityId: Number(data.cityId),
      stateId: Number(data.stateId),
      billingTypeId: Number(data.billingTypeId),
      refCode: data.refCode
    };

    // console.log('credential1222:', credential1);

    const SaveBankInfoApiResponse = await dispatch(saveAgreementBankInfo(credential1));

    if (SaveBankInfoApiResponse) {
      const savedData = SaveBankInfoApiResponse;
      // console.log('onSubmit ~ SaveBankInfoApiResponse:', SaveBankInfoApiResponse);
      localStorage.setItem('agreementId', JSON.stringify(savedData.data));

      const newReviewData = {
        ...reviewData,
        bankDetails: {
          bankName: selectedBank,
          bankAddress: data.bankAddress,
          bankAddress2: data.bankAddress2,
          panNumber: data.panNumber,
          gstin: data.gstin,
          bankCommissionTypeName: CommissionTypes.find(
            (c) => c.value === data.bankCommissionTypeId
          ),
          turnoverBenefit: TurnoverBenefitOptions.find((t) => t.value === data.turnoverBenefit),
          loginType: LoginTypes.find((l) => l.value === data.bankLoginTypeId),
          loginCode: data.loginCode,
          startDate: data.aggrementStartDate,
          cityId: data.cityId,
          stateId: data.stateId,
          refCode: data.refCode
        },
        agreementId: savedData?.agreementId,
        agreementBankId: savedData?.agreementBankId,
        bankMasterId: savedData?.bankMasterId
      };

      setReviewData(newReviewData);
      // console.log('onSubmit ~ newReviewData:', newReviewData);
      localStorage.setItem('reviewData', JSON.stringify(newReviewData));
      setActiveStep((activeStep) => activeStep + 1);
    } else {
      setOpenBankExist(true);
    }
  };

  const billingType = useCallback(() => {
    const creadintials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    dispatch(getBankTypeList(creadintials));
  }, []);

  useEffect(() => {
    billingType();
  }, [billingType]);

  useEffect(() => {
    const credential = {
      searchLiteral: null,
      countryId: 101
    };
    dispatch(getStateData(credential));
    dispatch(getBankDropdownData2({ companyId: LoginData?.companyId, userId: LoginData?.userId }));
  }, [LoginData, dispatch]);

  useEffect(() => {
    if (selectedState) {
      dispatch(getCityData({ stateId: Number(selectedState) }));
    }
  }, [selectedState, dispatch]);

  useEffect(() => {
    const authReviewData = JSON.parse(localStorage.getItem('reviewData'));
    if (authReviewData !== null) {
      const bd = authReviewData.bankDetails;
      reset({
        bankMasterId: String(authReviewData.bankMasterId || ''),
        bankLoginTypeId: String(bd.loginType?.value || bd.loginType?.typeId || ''),
        panNumber: bd.panNumber || '',
        gstin: bd.gstin || '',
        bankCommissionTypeId: String(
          bd.bankCommissionTypeName?.value || bd.bankCommissionTypeName?.typeId || ''
        ),
        turnoverBenefit: String(bd.turnoverBenefit?.value || bd.turnoverBenefit?.typeId || ''),
        loginCode: bd.loginCode || '',
        aggrementStartDate: bd.startDate || '',
        bankAddress: bd.bankAddress || '',
        bankAddress2: bd.bankAddress2 || '',
        cityId: String(bd.cityId || ''),
        stateId: String(bd.stateId || ''),
        refCode: bd.refCode || ''
      });
    } else if (location.pathname === '/agreement/edit' && AgreementEdit) {
      const bd = AgreementEdit.bankDetails;
      reset({
        bankMasterId: String(AgreementEdit.bankMasterId || ''),
        bankLoginTypeId: bd.bankLoginTypeName === 'DSA' ? '62' : '64',
        panNumber: bd.panNumber || '',
        gstin: bd.gstIn || '',
        bankCommissionTypeId: bd.bankCommissionTypeName === 'Branch' ? '68' : '66',
        turnoverBenefit: String(bd.turnoverBenefit),
        loginCode: bd.bankLoginCode || '',
        aggrementStartDate: AgreementEdit.agreementStartDate || '',
        bankAddress: bd.bankAddress || '',
        bankAddress2: bd.bankAddress2 || '',
        cityId: String(bd.cityId || ''),
        stateId: String(bd.stateId || ''),
        refCode: bd.refCode || ''
      });
    }
  }, [AgreementEdit, reset, location.pathname]);

  const localReviewData = JSON.parse(localStorage.getItem('reviewData')) || {};
  // console.log('AgreementEdit', AgreementEdit);
  // console.log('localReviewData', localReviewData);

  return (
    <>
      <Box className="viewLeadCard">
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <CustomSelect
              name="bankMasterId"
              label="Bank Name"
              control={control}
              errors={errors}
              isRequired
              placeholder="Select Bank Name"
              options={BankList}
              disabled={location.pathname === '/agreement/edit' || !!reviewData?.agreementId}
            />
          </Grid>
          <Grid item xs={4}>
            <CustomSelect
              name="billingTypeId"
              label="Bank Type"
              control={control}
              errors={errors}
              isRequired
              placeholder="Select Bank Type"
              options={BankTypeDrop}
            />
          </Grid>

          <Grid item xs={4}>
            <CustomSelect
              name="bankLoginTypeId"
              label="Login Type"
              control={control}
              errors={errors}
              isRequired
              options={LoginTypes}
            />
          </Grid>

          <Grid item xs={4}>
            <CustomInput
              name="panNumber"
              label="PAN No"
              control={control}
              errors={errors}
              isRequired
              placeholder="Type PAN No"
              fieldCode="PAN"
            />
          </Grid>

          <Grid item xs={4}>
            <CustomInput
              name="gstin"
              label="GSTIN"
              control={control}
              errors={errors}
              isRequired
              placeholder="Type GSTIN"
              fieldCode="GSTIN"
            />
          </Grid>

          <Grid item xs={4}>
            <CustomSelect
              name="bankCommissionTypeId"
              label="Commission Type"
              control={control}
              errors={errors}
              isRequired
              options={CommissionTypes}
            />
          </Grid>

          <Grid item xs={4}>
            <CustomSelect
              name="turnoverBenefit"
              label="Turnover Benefit"
              control={control}
              errors={errors}
              isRequired
              options={TurnoverBenefitOptions}
            />
          </Grid>

          <Grid item xs={4}>
            <CustomInput
              name="loginCode"
              label="DSA Code"
              control={control}
              errors={errors}
              isRequired
              placeholder="Type DSA Code"
            />
          </Grid>

          <Grid item xs={4}>
            <CustomDate
              name="aggrementStartDate"
              label="Date of Agreement "
              control={control}
              errors={errors}
              isRequired
              fieldCode="DATE"
              fieldType="DATE_FIELD"
            />
          </Grid>

          <Grid item xs={4}>
            <CustomInput
              name="bankAddress"
              label="Bank Address 1"
              control={control}
              errors={errors}
              isRequired
              placeholder="Enter Bank Address"
            />
          </Grid>

          <Grid item xs={4}>
            <CustomInput
              name="bankAddress2"
              label="Bank Address 2"
              control={control}
              errors={errors}
              placeholder="Enter Block/Floor/Area"
            />
          </Grid>

          <Grid item xs={4}>
            <CustomSelect
              name="stateId"
              label="State"
              control={control}
              errors={errors}
              isRequired
              options={stateDrop}
            />
          </Grid>

          <Grid item xs={4}>
            <CustomSelect
              name="cityId"
              label="City"
              control={control}
              errors={errors}
              isRequired
              options={CityDrop}
              disabled={!selectedState}
            />
          </Grid>

          <Grid item xs={4}>
            <CustomInput
              name="refCode"
              label="Reference Code"
              control={control}
              errors={errors}
              placeholder="Enter Ref Code (e.g. DST-001)"
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
        <Button
          onClick={handleSubmit(onSubmit)}
          className="mainBtn nextBtn"
          endIcon={<HiOutlineArrowNarrowRight />}
          variant="contained"
        >
          Next
        </Button>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{validationMsg}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Retry</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
